import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Box, IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const allLabels = [ 'Entre 1 a 10', 'Entre 11 y 50', 'Entre 51 y 100', 'Entre 101 y 250','Entre 251 y 1000', 'Más de 1,000'];

const employeeData2023 = [0, 14, 9, 10,24, 42];
const employeeData2024 = [2, 6, 4, 10, 28, 50];

const DistribucionEmpleadosHorizontalBar = ({ selectedIndustries = [], onIndustryClick = () => {} }) => {
  const [infoOpen, setInfoOpen] = useState(false);

  const chartData = {
    labels: allLabels,
    datasets: [
      {
        label: '2022',
        data: employeeData2023,
        backgroundColor: '#1F3D58',
        borderColor: '#fff',
        borderWidth: 1,
      },
      {
        label: '2023',
        data: employeeData2024,
        backgroundColor: '#A2AEBB',
        borderColor: '#fff',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    layout: {
      padding: {
        top: 20,
        bottom: 50,
        left: 10,
        right: 50, // Espacio adicional para etiquetas
      },
    },
    plugins: {
      legend: { position: 'top' },
      datalabels: {
        color: '#000',
        anchor: 'end', // Posiciona las etiquetas al final de las barras
        align: 'right', // Alineación hacia la derecha, afuera de las barras
        offset: 8, // Desplaza las etiquetas hacia afuera de la barra
        formatter: (value) => (value !== null ? `${value}%` : ''),
        font: { weight: 'bold', size: 12 }, // Formato de la etiqueta
        clip: false, // Evita recortes si está fuera del canvas
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}%`,
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Porcentaje (%)',
        },
        beginAtZero: true,
        max: 100,
        ticks: {
          stepSize: 10,
        },
      },
      y: {
        title: {
          display: true,
          text: 'Rango de Empleados',
        },
      },
    },
  };

  const infoContent = {
    Analisis: 'En 2023, las empresas más grandes son las más representativas, con la mayor presencia en el estudio. Las de tamaño mediano también tienen un peso importante, mientras que las más pequeñas son las menos frecuentes, reflejando un mercado dominado por organizaciones de mayor tamaño.',
    formula: 'Total de empleados en un rango / Total de empleados x 100',
    description: 'Muestra la proporción porcentual de empleados clasificados por rangos para cada año.',
  };

  return (
    <div style={{ width: '100%', height: '555px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Bar data={chartData} options={options} />
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
        <p><strong>Análisis:</strong> {infoContent.Analisis}</p>
          <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DistribucionEmpleadosHorizontalBar;